import { z } from 'zod';
const id = z.string().min(1).max(120);
const actorId = z.enum(['jordan', 'marcus', 'elena', 'noor', 'amara']);
const revision = z.string().regex(/^[a-f0-9]{64}$/);
export const fieldShareObservationSchema = z.enum(['source', 'runs']);
export const fieldSubscriptionEventSchema = z.enum(['pr.revised', 'run.completed']);
const purpose = z.string().trim().min(1).max(1000);
const scope = z.object({ actorId, prId: id, revision, purpose });
export const fieldShareSessionSchema = scope.extend({
    id,
    observations: z.array(fieldShareObservationSchema).min(1).max(2),
    createdAt: z.string(),
    refreshedAt: z.string(),
    expiresAt: z.string(),
    revokedAt: z.string().nullable(),
    origin: z.literal('learner'),
});
export const fieldSubscriptionSchema = scope.extend({
    id,
    events: z.array(fieldSubscriptionEventSchema).min(1).max(2),
    createdAt: z.string(),
    expiresAt: z.string(),
    revokedAt: z.string().nullable(),
    origin: z.literal('learner'),
});
export const fieldSharingActionSchemas = [
    scope.extend({
        type: z.literal('sharing.start'),
        observations: z.array(fieldShareObservationSchema).min(1).max(2),
        minutes: z.number().int().min(1).max(120),
    }),
    z.object({ type: z.literal('sharing.refresh'), shareId: id, revision }),
    z.object({ type: z.literal('sharing.revoke'), shareId: id }),
    scope.extend({
        type: z.literal('sharing.subscribe'),
        events: z.array(fieldSubscriptionEventSchema).min(1).max(2),
        minutes: z.number().int().min(1).max(10080),
    }),
    z.object({ type: z.literal('sharing.unsubscribe'), subscriptionId: id }),
];
export const fieldSharingActionSchema = z.discriminatedUnion('type', fieldSharingActionSchemas);
